import React from "react";
import { Switch, Route } from "react-router-dom";

import ItemsRouter from "./Items";
import ItemCategoriesRouter from "./ItemCategories";
import InventoryStorageDimsRouter from "./InventoryStorageDims";
import ItemTransactionsRouter from "./ItemTransactions";
import InventoryOnHandRouter from "./InventoryOnHand";

const InventoryManagementRouter = () => (
  <Switch>
    <Route path="/inventory/items">
      <ItemsRouter />
    </Route>
    <Route path="/inventory/item-categories">
      <ItemCategoriesRouter />
    </Route>
    <Route path="/inventory/item-transactions">
      <ItemTransactionsRouter />
    </Route>
    <Route path="/inventory/storage-dims">
      <InventoryStorageDimsRouter />
    </Route>
    <Route path="/inventory/inventory-on-hand">
      <InventoryOnHandRouter />
    </Route>
  </Switch>
);

export default InventoryManagementRouter;
